<template>
  <the-navbar />
  <the-jumbotron />
  <div class="bg-gray-200 pt-12">
    <div class="container mx-auto px-8 md:px-0">
      <h2 class="text-2xl font-bold text-gray-800">
        Find the best deals in your city
      </h2>

      <p class="text-gray-500">
        Browse through the best listings before they reach the market
      </p>
    </div>
    <biew-widget
      id="oou3MJfsq3N7UZm5FnRi"
      uid="qUrk51rlQiYERcQyO2pi0n75FdG2"
    ></biew-widget>
  </div>
  <the-footer />
</template>

<script>
import TheFooter from "@/components/TheFooter";
import TheJumbotron from "@/components/TheJumbotron";
import TheNavbar from "@/components/TheNavbar";

export default {
  name: "App",

  components: {
    TheFooter,
    TheJumbotron,
    TheNavbar
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
</style>
